import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { getAppliedReferral, saveAppliedReferral, validateAppliedReferral } from "../../helpers/applied.referral";
import { showToast } from "../../helpers/show.toast";

export default function ReferralTracker() {
  const [params, setParams] = useSearchParams();
  const token = useSelector((state) => state.common.token);
  const search = params.toString();

  useEffect(() => {
    const query = new URLSearchParams(search);
    const incoming = (query.get("referral_code") || query.get("referral") || "").trim();
    if (incoming) {
      saveAppliedReferral(incoming, query.get("referrer") || query.get("name") || query.get("username") || "");
      ["referral_code", "referral", "referrer", "name", "username"].forEach((key) => query.delete(key));
      setParams(query, { replace: true });
      return;
    }
    const code = getAppliedReferral();
    if (!code || !localStorage.getItem("token")) return;
    let active = true;
    validateAppliedReferral(code).catch((error) => {
      if (active) showToast("Referral code", error.message || "Unable to validate referral code. Please try again.", "error");
    });
    return () => { active = false; };
  }, [search, token, setParams]);
  return null;
}
